<template>
    <div class="story-maker-sticker-menu-link">
        <div class="header-menu">
            <p>Ajoutez un lien</p>
        </div>
        <div class="content">
            
            <div class="form">
                <div class="container-input">
                    <div class="input input-link">
                        <i class="fa-regular fa-link"></i>
                        <input placeholder="Ajoutez une URL" v-model="models.link">
                    </div>
                    <p class="error">{{ error }}</p>
                </div>
                
                <p v-if="!showEditText" @click="toogleDisplayAddText" class="add-text"><i class="fa-solid fa-plus"></i> Personnaliser le texte du sticker</p>
                <p v-else="" @click="toogleDisplayAddText" class="add-text">Retirer la personnalisation</p>
                
                <div v-if="showEditText" class="container-input">
                    <div class="input input-text">
                        <input placeholder="Texte du sticker" v-model="models.text">
                    </div>
                </div>

            </div>
           
            <div class="button" @click="finish">
                Ajoutez
            </div>
        </div>
        
    </div>
</template>


<script>
export default {
    data() {
        return {
            models: {
                link : '',
                text: '',
            },
            showEditText : false,
            error : ''
        }
    },
    
    methods: {
        finish() {      
            this.error = ''      
            if (!this.validURL(this.models.link)){
                this.error = 'adresse invalide'
                return
            }
           
            this.$emit('addSticker','link', {
                data: {
                    ...this.models,
                    styleVariant: 1
                }
            })
        },

        validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
            return !!pattern.test(str);
        },

        toogleDisplayAddText() {

            this.showEditText = !this.showEditText
            this.models.text = ''
        }
    },
}
</script>

<style lang="scss" scoped>

</style>